const formatDate = (dateStr, includeTime = false) => {
  const date = new Date(dateStr);
  if (!(date instanceof Date) || isNaN(date)) return null;

  const day = date.getDate();
  const suffix =
    day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? "rd"
      : "th";
  const month = date.toLocaleString("en-GB", { month: "long" });
  const year = date.getFullYear();
  const formattedDate = `${day}${suffix} ${month} ${year}`;

  if (!includeTime) return formattedDate;

  const time = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${formattedDate} at ${time}`;
};

export default formatDate;
